import { nanoid } from "nanoid";
import { HE, IBlock } from "../types";
import EventEmitter from "./eventEmitter";
import { $createEl, creatBlock } from "../utils/domHelpers";
import { blocks as defaultBlocks } from "./defaults";

class BlockManager {
  public blocks: Record<string, IBlock> = {};

  constructor(private containerElem: HE, private ee: EventEmitter) {}

  init() {
    defaultBlocks.forEach((block) => this.add(block));
  }

  add(block: IBlock) {
    if (!this.blocks[block.type]) {
      const defaults: Partial<IBlock> = {
        id: nanoid(10),
        draggable: true,
        droppable: true,
      };

      block = { ...defaults, ...block };

      this.blocks[block.type] = block;
      this.appendBlock(block);
    }
  }

  private appendBlock(block: IBlock) {
    const blockElem = creatBlock(block.id || "", block.type);
    const blockIcon = $createEl("div");
    const blockHeading = $createEl("h3", block.name);

    blockIcon.innerHTML = block.icon;
    blockElem.append(blockIcon);
    blockElem.append(blockHeading);

    this.containerElem.append(blockElem);
  }

  show() {
    this.containerElem.classList.add("show");
  }

  hide() {
    this.containerElem.classList.remove("show");
  }
}

export default BlockManager;
